module.exports = __webpack_public_path__ + "img/yakiton_logo.7e3aa3d4.png";